import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface IConversationFeedback {
  readonly id: string;
  readonly type: MESSAGES.CONVERSATION_FEEDBACK;
  readonly nodeId: string;
  readonly rm: boolean;
  readonly role: ROLE.BOT;
  readonly avatar: boolean;
}

export const createConversationFeedback = (data: {
  id?: string;
  _id?: string;
  nodeId?: string;
  rm?: boolean;
}): IConversationFeedback => ({
  id: data.id ?? data._id ?? uuid(),
  type: MESSAGES.CONVERSATION_FEEDBACK,
  nodeId: data.nodeId ?? '',
  rm: Boolean(data.rm),
  role: ROLE.BOT,
  avatar: true,
});
